// Each marketplace's logo is a single file, public/assets/icons/app/<platform>.svg, and every screen
// shows a marketplace's logo through getPlatformIconUrl, so replacing that file changes the logo
// everywhere in the app.
const ICON_FOLDER = '/assets/icons/app';

// Platform keys can be camelCase ('wooCommerce') while the files are named in lower case. A record
// with no platform shows the generic marketplace icon.
export function getPlatformIconUrl (platform) {
  if (!platform) return `${ICON_FOLDER}/marketplace.svg`;
  return `${ICON_FOLDER}/${platform.toLowerCase()}.svg`;
}
